// Enhanced product-bundle-builder.js with Buy X Get Y Free functionality - FIXED DROPDOWNS

// Prevent multiple initializations
if (!window.bundleBuilderInitialized) {
  window.bundleBuilderInitialized = true;

  class ProductBundleBuilder extends HTMLElement {
    constructor() {
      super();
      
      // Check if already initialized for this instance
      if (this.initialized) return;
      this.initialized = true;
      
      this.selectedProducts = new Map();
      this.currency = this.dataset.currency || '${{amount}} AUD';
      this.bundleDiscount = parseFloat(this.dataset.bundleDiscount) || 0;
      this.blockId = this.dataset.blockId;
      this.productId = this.dataset.productId;
      
      // New: Buy X Get Y Free settings
      this.discountType = this.dataset.discountType || 'percentage'; // 'percentage' or 'bxgy'
      this.bxgySettings = {
        requiredStep: this.dataset.bxgyRequiredStep || '1', // Which step contains the "buy" products
        freeStep: this.dataset.bxgyFreeStep || '2', // Which step contains the "get free" products
        requiredCount: parseInt(this.dataset.bxgyRequiredCount) || 1, // How many to buy
        freeCount: parseInt(this.dataset.bxgyFreeCount) || 1 // How many free
      };
      // Preselection setting
      this.disablePreselection = this.dataset.disablePreselection === 'true';
      console.log('BXGY Settings:', this.bxgySettings);
      console.log('Discount Type:', this.discountType);
      
      // Track open dropdowns
      this.openDropdown = null;
      
      // Bind context for methods
      this.removeSelection = this.removeSelection.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    connectedCallback() {
      // Only initialize when element is connected to DOM
      if (!this.hasAttribute('data-initialized')) {
        this.setAttribute('data-initialized', 'true');
        this.init();
      }
    }

    disconnectedCallback() {
      // Clean up event listeners when removed from DOM
      this.cleanup();
    }

    init() {
      // Prevent double initialization
      if (this._isInitialized) return;
      this._isInitialized = true;
      
      console.log(`Initializing bundle builder: Block ${this.blockId}, Product ${this.productId}`);
      console.log(`Discount Type: ${this.discountType}, BXGY Settings:`, this.bxgySettings);
      
      this.setupSelectors();
      this.setupEventListeners();
      
      // Use setTimeout to ensure DOM is ready and event listeners are attached
      setTimeout(() => {
        if (!this.disablePreselection) {
          this.preselectCurrentProduct();
        }
      }, 100);
      
      this.updateSummary();
    }

    cleanup() {
      // Remove global event listeners
      document.removeEventListener('click', this.handleDocumentClick);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      
      // Clean up any open dropdowns
      this.closeAllDropdowns();
    }

    setupSelectors() {
      this.selectors = this.querySelectorAll('select-dropdown');
      this.summary = this.querySelector('[data-bundle-summary]');
      this.addToCartBtn = this.querySelector('[data-add-bundle]');
      this.errorContainer = this.querySelector('[data-bundle-error]');
      
      // Assign indices and total for positioning logic
      this.totalSelectors = this.selectors.length;
      this.selectors.forEach((selector, index) => {
        selector.dataset.selectorIndex = (index + 1).toString();
        selector.dataset.totalSelectors = this.totalSelectors.toString();
      });
    }

    setupEventListeners() {
      // Handle dropdown toggles
      this.selectors.forEach(selector => {
        const trigger = selector.querySelector('.bundle-selector-trigger');
        const dropdown = selector.querySelector('.bundle-selector-dropdown');
        
        // Remove any existing listeners first
        const newTrigger = trigger.cloneNode(true);
        trigger.parentNode.replaceChild(newTrigger, trigger);
        
        newTrigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown(selector);
        });

        // Handle option selections
        const inputs = selector.querySelectorAll('input');
        inputs.forEach(input => {
          // Use unique event handler per instance
          input.addEventListener('change', (e) => {
            this.handleSelection(e, selector);
          });
        });
      });

      // Close dropdowns when clicking outside
      document.addEventListener('click', this.handleDocumentClick);

      // Handle scroll and resize events
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      // Add to cart
      if (this.addToCartBtn) {
        // Remove any existing listeners
        const newBtn = this.addToCartBtn.cloneNode(true);
        this.addToCartBtn.parentNode.replaceChild(newBtn, this.addToCartBtn);
        this.addToCartBtn = newBtn;
        
        this.addToCartBtn.addEventListener('click', () => {
          this.addBundleToCart();
        });
      }

      // Make removeSelection available globally for this instance
      window[`bundleBuilder_${this.blockId}_removeSelection`] = this.removeSelection;
    }

    handleDocumentClick(e) {
      // Don't close if clicking inside a dropdown
      const clickedDropdown = e.target.closest('.bundle-selector-dropdown');
      const clickedTrigger = e.target.closest('.bundle-selector-trigger');
      
      if (!clickedDropdown && !clickedTrigger) {
        this.closeAllDropdowns();
      }
    }

    preselectCurrentProduct() {
      console.log('Attempting to preselect current product...');
      
      // Find the main product selector (step 1)
      const mainProductSelector = this.querySelector('[data-step="1"]');
      if (!mainProductSelector) {
        console.log('Main product selector not found');
        return;
      }

      // Try multiple strategies to find the current product
      let defaultInput = mainProductSelector.querySelector('input[data-default="true"]');
      
      // If no default is marked, try to find by product ID
      if (!defaultInput && this.productId) {
        defaultInput = mainProductSelector.querySelector(`input[data-product-id="${this.productId}"]`);
        console.log(`Looking for product with ID ${this.productId}:`, defaultInput ? 'found' : 'not found');
      }
      
      // If still not found, select the first available option
      if (!defaultInput) {
        defaultInput = mainProductSelector.querySelector('input[type="radio"]');
        console.log('Selecting first available option:', defaultInput ? 'found' : 'not found');
      }
      
      if (defaultInput) {
        // Check the input
        defaultInput.checked = true;
        
// Get the item data including metafields
        const itemData = {
          variantId: defaultInput.value,
          productId: defaultInput.dataset.productId,
          title: defaultInput.dataset.title,
          variantTitle: defaultInput.dataset.variantTitle || null,
          price: parseFloat(defaultInput.dataset.price),
          comparePrice: parseFloat(defaultInput.dataset.comparePrice) || null,
          image: defaultInput.dataset.image,
          metafield1: defaultInput.dataset.metafield1 || null,
          metafield2: defaultInput.dataset.metafield2 || null
        };
        
        // Update the selection
        this.updateStepSelection('1', [itemData]);
        this.updateSelectedItemsDisplay('1');
        this.updateSummary();
        this.validateBundle();
        this.updateBXGYInstructions();
        
        console.log('Pre-selected product:', itemData.title);
      } else {
        console.log('No product found to preselect');
      }
    }

    toggleDropdown(selector) {
      const trigger = selector.querySelector('.bundle-selector-trigger');
      const dropdown = selector.querySelector('.bundle-selector-dropdown');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.closeDropdown(selector);
      } else {
        // Close all other dropdowns first
        this.closeAllDropdowns();
        
        // Open this dropdown
        trigger.setAttribute('aria-expanded', 'true');
        dropdown.hidden = false;
        this.openDropdown = selector;
        
        // Set parent to relative
        selector.style.position = 'relative';
        
        // Position the dropdown after it's visible
        requestAnimationFrame(() => {
          this.positionDropdown(selector, dropdown);
        });
      }
    }

    positionDropdown(selector, dropdown) {
      // Reset any previous positioning
      dropdown.style.cssText = '';
      
      // Get the trigger button position
      const trigger = selector.querySelector('.bundle-selector-trigger');
      const triggerRect = trigger.getBoundingClientRect();
      
      // Check if we're in a modal
      const modal = this.closest('.modal-content, .popup-content, [role="dialog"], .modal__inner, .popup__inner, .bundle-builder-modal');
      
      if (modal) {
        // For modal view, position absolutely relative to selector
        requestAnimationFrame(() => {
          const dropdownRect = dropdown.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          
          const totalSelectors = parseInt(selector.dataset.totalSelectors);
          const selectorIndex = parseInt(selector.dataset.selectorIndex);
          
          let shouldOpenUp = false;
          
          if (totalSelectors === 2 && selectorIndex === 2) {
            shouldOpenUp = false;
          } else if (totalSelectors === 3 && selectorIndex === 3) {
            shouldOpenUp = true;
          } else {
            // Default logic
            if (dropdownRect.bottom > viewportHeight - 20) {
              // Calculate available space above and below
              const spaceAbove = triggerRect.top;
              const spaceBelow = viewportHeight - triggerRect.bottom;
              const dropdownHeight = dropdownRect.height;
              
              // If more space above and dropdown fits, position above
              if (spaceAbove > spaceBelow && spaceAbove > dropdownHeight + 20) {
                shouldOpenUp = true;
              }
            }
          }
          
          console.log(`Positioning dropdown: total=${totalSelectors}, index=${selectorIndex}, openUp=${shouldOpenUp}`);
          
          dropdown.style.position = 'absolute';
          dropdown.style.left = '0';
          dropdown.style.width = '100%';
          dropdown.style.zIndex = '10';

          if (shouldOpenUp) {
            dropdown.style.top = 'auto';
            dropdown.style.bottom = '100%';
            dropdown.style.marginBottom = '8px';
          } else {
            dropdown.style.top = '100%';
            dropdown.style.bottom = 'auto';
            dropdown.style.marginTop = '8px';
          }
        });
      }
    }

    handleScroll() {
      // Close all dropdowns on scroll to prevent positioning issues
      if (this.openDropdown) {
        this.closeAllDropdowns();
      }
    }

    handleResize() {
      // Close dropdowns on resize to prevent positioning issues
      this.closeAllDropdowns();
    }

    closeAllDropdowns() {
      this.querySelectorAll('.bundle-selector-trigger').forEach(trigger => {
        const selector = trigger.closest('select-dropdown');
        const dropdown = trigger.nextElementSibling;
        if (dropdown && !dropdown.hidden) {
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.hidden = true;
          // Reset any positioning
          dropdown.style.cssText = '';
          if (selector) selector.style.position = '';
        }
      });
      this.openDropdown = null;
    }

    closeDropdown(selector) {
      const trigger = selector.querySelector('.bundle-selector-trigger');
      const dropdown = selector.querySelector('.bundle-selector-dropdown');
      
      if (trigger && dropdown) {
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.hidden = true;
        // Reset any positioning
        dropdown.style.cssText = '';
        selector.style.position = '';
        
        if (this.openDropdown === selector) {
          this.openDropdown = null;
        }
      }
    }

    handleSelection(event, selector) {
      const input = event.target;
      const step = selector.dataset.step;
      const maxSelections = parseInt(selector.dataset.maxSelections);
      const selectedItemsContainer = this.querySelector(`[data-selected-items="${step}"]`);

// Get data from input including metafields
      const itemData = {
        variantId: input.value,
        productId: input.dataset.productId,
        title: input.dataset.title,
        variantTitle: input.dataset.variantTitle || null,
        price: parseFloat(input.dataset.price),
        comparePrice: parseFloat(input.dataset.comparePrice) || null,
        image: input.dataset.image,
        // Add metafield data
        metafield1: input.dataset.metafield1 || null,
        metafield2: input.dataset.metafield2 || null
      };

      // Handle radio buttons (max 1 selection)
      if (input.type === 'radio') {
        this.updateStepSelection(step, [itemData]);
        // Close dropdown for radio buttons
        setTimeout(() => this.closeDropdown(selector), 100);
      } else {
        // Handle checkboxes (multiple selections)
        const checkedInputs = selector.querySelectorAll('input:checked');
        
        // Special handling for BXGY free items
        if (this.discountType === 'bxgy' && step === this.bxgySettings.freeStep) {
          const maxFreeItems = this.getMaxFreeItems();
          if (checkedInputs.length > maxFreeItems) {
            input.checked = false;
            this.showError(`You can select up to ${maxFreeItems} free items based on your main product selection`);
            return;
          }
        } else if (checkedInputs.length > maxSelections) {
          input.checked = false;
          this.showError(`Maximum ${maxSelections} selections allowed for this step`);
          return;
        }

const selections = Array.from(checkedInputs).map(checkedInput => ({
          variantId: checkedInput.value,
          productId: checkedInput.dataset.productId,
          title: checkedInput.dataset.title,
          variantTitle: checkedInput.dataset.variantTitle || null,
          price: parseFloat(checkedInput.dataset.price),
          comparePrice: parseFloat(checkedInput.dataset.comparePrice) || null,
          image: checkedInput.dataset.image,
          metafield1: checkedInput.dataset.metafield1 || null,
          metafield2: checkedInput.dataset.metafield2 || null
        }));

        this.updateStepSelection(step, selections);
        
        // Close dropdown when max selections reached
        const effectiveMax = (this.discountType === 'bxgy' && step === this.bxgySettings.freeStep) 
          ? this.getMaxFreeItems() 
          : maxSelections;
          
        if (checkedInputs.length >= effectiveMax) {
          setTimeout(() => this.closeDropdown(selector), 100);
        }
      }

      this.updateSelectedItemsDisplay(step);
      this.updateSummary();
      this.validateBundle();
      this.updateBXGYInstructions();
    }

    // New method: Calculate max free items based on required selections
    getMaxFreeItems() {
      if (this.discountType !== 'bxgy') return 999;
      
      const requiredSelections = this.selectedProducts.get(this.bxgySettings.requiredStep) || [];
      const qualifyingCount = requiredSelections.length;
      
      // Calculate how many free items they can get
      const setsQualified = Math.floor(qualifyingCount / this.bxgySettings.requiredCount);
      const totalFree = setsQualified * this.bxgySettings.freeCount;
      
      console.log(`Qualifying count: ${qualifyingCount}, Sets qualified: ${setsQualified}, Total free allowed: ${totalFree}`);
      
      return totalFree;
    }

    // New method: Update BXGY instructions
    updateBXGYInstructions() {
      if (this.discountType !== 'bxgy') return;
      
      const freeStep = this.querySelector(`[data-step="${this.bxgySettings.freeStep}"]`);
      if (!freeStep) return;
      
      const maxFree = this.getMaxFreeItems();
      const currentFree = (this.selectedProducts.get(this.bxgySettings.freeStep) || []).length;
      
      // Update step title or add instruction
      const stepTitle = freeStep.querySelector('.bundle-step-title');
      const existingInstruction = freeStep.querySelector('.bxgy-instruction');
      
      if (existingInstruction) {
        existingInstruction.remove();
      }
      
      if (maxFree > 0) {
        const instruction = document.createElement('div');
        instruction.className = 'bxgy-instruction';
        instruction.style.cssText = 'font-size: 0.875rem; color: var(--sale_text_color); margin-top: 0.5rem;';
        instruction.textContent = `You can select ${maxFree} free item${maxFree > 1 ? 's' : ''} (${currentFree} selected)`;
        stepTitle.parentNode.appendChild(instruction);
      }
    }

    updateStepSelection(step, selections) {
      if (selections.length === 0) {
        this.selectedProducts.delete(step);
      } else {
        this.selectedProducts.set(step, selections);
      }
    }

    updateSelectedItemsDisplay(step) {
      const container = this.querySelector(`[data-selected-items="${step}"]`);
      const selections = this.selectedProducts.get(step) || [];
      
      // Get metafield labels from block settings
      const blockElement = this.closest('[data-block-id]');
      const metafield1Label = blockElement?.dataset.metafield1Label || this.dataset.metafield1Label;
      const metafield2Label = blockElement?.dataset.metafield2Label || this.dataset.metafield2Label;
      
      container.innerHTML = selections.map(item => {
        let metafieldHtml = '';
        
        if (item.metafield1) {
          metafieldHtml += `<div class="selected-item-metafield">${metafield1Label || 'Info'}: ${item.metafield1}</div>`;
        }
        
        if (item.metafield2) {
          metafieldHtml += `<div class="selected-item-metafield">${metafield2Label || 'Info'}: ${item.metafield2}</div>`;
        }
        
        return `
          <div class="selected-item">
            <div class="selected-item-info">
              <span class="selected-item-title">${item.title}</span>
              ${metafieldHtml}
            </div>
            <button type="button" onclick="window.bundleBuilder_${this.blockId}_removeSelection('${step}', '${item.variantId}')">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        `;
      }).join('');

      // Update dropdown trigger text
      const selector = this.querySelector(`[data-step="${step}"]`);
      const trigger = selector.querySelector('.selected-text');
      if (selections.length > 0) {
        trigger.textContent = selections.length === 1 
          ? selections[0].title 
          : `${selections.length} items selected`;
      } else {
        trigger.textContent = selector.querySelector('.bundle-selector-trigger').dataset.placeholder || 'Choose an option';
      }
    }

    removeSelection(step, variantId) {
      console.log(`Removing selection: step ${step}, variant ${variantId}`);
      
      const selections = this.selectedProducts.get(step) || [];
      const updatedSelections = selections.filter(item => item.variantId !== variantId);
      
      // Update the internal state
      this.updateStepSelection(step, updatedSelections);
      
      // Find and uncheck the corresponding input
      const selector = this.querySelector(`[data-step="${step}"]`);
      if (selector) {
        const input = selector.querySelector(`input[value="${variantId}"]`);
        if (input) {
          input.checked = false;
          console.log(`Unchecked input for variant ${variantId}`);
        }
      }
      
      // Update UI
      this.updateSelectedItemsDisplay(step);
      this.updateSummary();
      this.validateBundle();
      this.updateBXGYInstructions();
    }

    updateSummary() {
      const summaryItems = this.summary.querySelector('.summary-items');
      const summaryPricing = this.summary.querySelector('.summary-pricing');
      
      let allItems = [];
      let allItemsWithStep = []; // Track which step each item comes from
      
      this.selectedProducts.forEach((items, step) => {
        items.forEach(item => {
          allItems.push(item);
          allItemsWithStep.push({ ...item, step });
        });
      });

      if (allItems.length === 0) {
        summaryItems.innerHTML = '<div class="summary-placeholder"><p>Select items to build your bundle</p></div>';
        if (summaryPricing) summaryPricing.hidden = true;
        return;
      }

      // Get metafield labels
      const blockElement = this.closest('[data-block-id]');
      const metafield1Label = blockElement?.dataset.metafield1Label || this.dataset.metafield1Label;
      const metafield2Label = blockElement?.dataset.metafield2Label || this.dataset.metafield2Label;

      // Determine which items are free (for BXGY)
      const freeItems = new Set();
      let freeItemsCount = 0;
      
      if (this.discountType === 'bxgy') {
        const maxFree = this.getMaxFreeItems();
        console.log(`Max free items allowed: ${maxFree}`);
        
        // Mark items from the free step as free (up to the max allowed)
        allItemsWithStep.forEach(item => {
          if (item.step === this.bxgySettings.freeStep && freeItemsCount < maxFree) {
            freeItems.add(item.variantId);
            freeItemsCount++;
            console.log(`Marking ${item.title} as free (${freeItemsCount}/${maxFree})`);
          }
        });
      }

      // Display selected items with metafields
      summaryItems.innerHTML = allItemsWithStep.map(item => {
        let metafieldHtml = '';
        
        if (item.metafield1) {
          metafieldHtml += `<div class="summary-item-metafield">${metafield1Label || 'Info'}: ${item.metafield1}</div>`;
        }
        
        if (item.metafield2) {
          metafieldHtml += `<div class="summary-item-metafield">${metafield2Label || 'Info'}: ${item.metafield2}</div>`;
        }
        
        // Calculate price display
        let priceHtml = '';
        const isFree = freeItems.has(item.variantId);
        
        const originalPrice = Math.max(item.comparePrice || 0, item.price);
        if (isFree) {
          priceHtml = `
            <div class="summary-item-price has-discount">
              <span class="summary-item-original-price">${this.formatMoney(originalPrice)}</span>
              <span class="summary-item-discounted-price" style="color: var(--sale_text_color);">FREE</span>
            </div>
          `;
        } else if (this.discountType === 'percentage' && this.bundleDiscount > 0) {
          const discountedPrice = item.price * (1 - this.bundleDiscount / 100);
          priceHtml = `
            <div class="summary-item-price has-discount">
              <span class="summary-item-original-price">${this.formatMoney(originalPrice)}</span>
              <span class="summary-item-discounted-price">${this.formatMoney(discountedPrice)}</span>
            </div>
          `;
        } else {
          priceHtml = `<span class="summary-item-price">${this.formatMoney(item.price)}</span>`;
        }
        
        return `
          <div class="summary-item">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
            <div class="summary-item-details">
              <span class="summary-item-title">${item.title}</span>
              ${item.variantTitle && item.variantTitle !== 'Default Title' ? `<span class="summary-item-variant">${item.variantTitle}</span>` : ''}
              ${metafieldHtml}
              ${priceHtml}
            </div>
          </div>
        `;
      }).join('');

      // Calculate pricing
      let subtotal = 0;
      let discount = 0;

      allItemsWithStep.forEach(item => {
        // Subtotal shows RRP (compare-at) so storewide sale savings count toward the bundle discount line
        const originalPrice = Math.max(item.comparePrice || 0, item.price);
        subtotal += originalPrice;

        if (freeItems.has(item.variantId)) {
          // Free items contribute their full price to the discount
          discount += originalPrice;
        } else if (this.discountType === 'percentage' && this.bundleDiscount > 0) {
          discount += originalPrice - item.price * (1 - this.bundleDiscount / 100);
        } else {
          discount += originalPrice - item.price;
        }
      });

      const total = subtotal - discount;

      // Update pricing display
      const subtotalRow = this.summary.querySelector('.pricing-row:has([data-subtotal])');
      const discountRow = this.summary.querySelector('.pricing-row.discount');
      const totalRow = this.summary.querySelector('.pricing-row.total');

      if (subtotalRow) {
        subtotalRow.innerHTML = `
          <span>Subtotal</span>
          <span data-subtotal>${this.formatMoney(subtotal)}</span>
        `;
      }

      if (discount > 0 && discountRow) {
        let discountLabel = '';
        if (this.discountType === 'bxgy') {
          const freeCount = freeItems.size;
          discountLabel = `Free Items (${freeCount})`;
        } else {
          discountLabel = 'Bundle Discount';
        }
        
        discountRow.innerHTML = `
          <span>${discountLabel}</span>
          <span data-discount>-${this.formatMoney(discount)}</span>
        `;
        discountRow.style.display = '';
      } else if (discountRow) {
        discountRow.style.display = 'none';
      }

      if (totalRow) {
        totalRow.innerHTML = `
          <span>Total</span>
          <span data-total>${this.formatMoney(total)}</span>
        `;
      }

      // Show pricing section
      if (summaryPricing) summaryPricing.hidden = false;
    }

    validateBundle() {
      const requiredSteps = Array.from(this.querySelectorAll('[data-required="true"]'));
      const allRequiredFilled = requiredSteps.every(step => {
        const stepNumber = step.dataset.step;
        return this.selectedProducts.has(stepNumber) && this.selectedProducts.get(stepNumber).length > 0;
      });

      this.addToCartBtn.disabled = !allRequiredFilled;
      
      if (!allRequiredFilled) {
        this.addToCartBtn.title = 'Please complete all required steps';
      } else {
        this.addToCartBtn.title = '';
      }
    }

    async addBundleToCart() {
      this.hideError();
      this.setLoading(true);

      try {
        const items = [];
        
        // First, collect all items with their step info
        let allItemsWithStep = [];
        this.selectedProducts.forEach((selections, step) => {
          selections.forEach(item => {
            allItemsWithStep.push({ ...item, step });
          });
        });
        
        // Determine which items are free
        const freeItems = new Set();
        let freeItemsCount = 0;
        
        if (this.discountType === 'bxgy') {
          const maxFree = this.getMaxFreeItems();
          
          // Mark items from the free step as free
          allItemsWithStep.forEach(item => {
            if (item.step === this.bxgySettings.freeStep && freeItemsCount < maxFree) {
              freeItems.add(item.variantId);
              freeItemsCount++;
            }
          });
        }
        
        // Build items array with appropriate properties
        allItemsWithStep.forEach(item => {
          const isFree = freeItems.has(item.variantId);
          const properties = {
            '_bundle_id': Date.now().toString(),
            '_bundle_block': this.blockId
          };
          
          if (this.discountType === 'bxgy' && isFree) {
            properties['_bundle_free_item'] = 'true';
            properties['_original_price'] = (item.price / 100).toFixed(2);
          } else if (this.discountType === 'percentage' && this.bundleDiscount > 0) {
            properties['_bundle_discount'] = `${this.bundleDiscount}%`;
          }
          
          items.push({
            id: item.variantId,
            quantity: 1,
            properties
          });
        });

        if (items.length === 0) {
          throw new Error('No items selected');
        }

        // Debug logging
        console.log('Adding bundle items to cart:', items);

        // Add items to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items })
        });

        console.log('Response status:', response.status);
        
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Failed to add bundle to cart');
        }

        const responseData = await response.json();
        console.log('Bundle added successfully:', responseData);

        // Force cart refresh
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        console.log('Updated cart:', cart);

        // Update cart count
        this.updateCartCount(cart.item_count);

        // Trigger cart update events
        this.triggerCartUpdate(cart);

        // Open cart drawer or redirect
        await this.openCart(cart);

        // Reset selections
        this.resetBuilder();

      } catch (error) {
        console.error('Error adding bundle to cart:', error);
        this.showError(error.message);
      } finally {
        this.setLoading(false);
      }
    }

    updateCartCount(count) {
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(el => {
        if (count === 0) {
          el.classList.add('hidden');
          el.textContent = '';
        } else if (count > 99) {
          el.classList.remove('hidden');
          el.classList.add('large-items');
          el.textContent = '';
        } else {
          el.classList.remove('hidden', 'large-items');
          el.textContent = count;
        }
      });
    }

    triggerCartUpdate(cart) {
      // Trigger multiple cart update events for theme compatibility
      const events = [
        new CustomEvent('cart:update', { detail: { cart, source: 'bundle-builder' } }),
        new CustomEvent('cart:count:update', { detail: { count: cart.item_count } }),
        new CustomEvent('cart:refresh', { detail: { cart } }),
        new CustomEvent('ajaxCart:update', { detail: { cart } })
      ];

      events.forEach(event => document.dispatchEvent(event));

      // Try theme-specific updates
      if (window.CartDrawer?.refresh) window.CartDrawer.refresh();
      if (window.theme?.cart?.getCart) window.theme.cart.getCart();
      if (window.cart?.getCart) window.cart.getCart();
    }

    async openCart(cart) {
      const cartDrawer = document.querySelector('cart-drawer, [data-cart-drawer], #cart-drawer');
      
      if (cartDrawer) {
        // Update cart drawer content
        if (cartDrawer.renderContents) {
          const sectionsResponse = await fetch('/cart?sections=cart-drawer');
          const sections = await sectionsResponse.json();
          cartDrawer.renderContents({ sections, cart });
        } else {
          // Fallback: manually update content
          const response = await fetch('/cart?section_id=cart-drawer');
          const html = await response.text();
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, 'text/html');
          const newContent = newDoc.querySelector('[data-cart-drawer-content], .cart-drawer__content');
          const currentContent = cartDrawer.querySelector('[data-cart-drawer-content], .cart-drawer__content');
          
          if (newContent && currentContent) {
            currentContent.innerHTML = newContent.innerHTML;
          }
        }
        
        // Open cart drawer
        if (cartDrawer.open) {
          cartDrawer.open();
        } else {
          // Try various methods to open cart
          const cartToggle = document.querySelector('[data-cart-toggle], [data-source="cart-drawer"], .js-drawer-open-right');
          if (cartToggle) cartToggle.click();
        }
      } else {
        // No cart drawer, redirect to cart page
        window.location.href = '/cart';
      }
    }

    resetBuilder() {
      this.selectedProducts.clear();
      this.querySelectorAll('input:checked').forEach(input => {
        input.checked = false;
      });
      this.querySelectorAll('[data-selected-items]').forEach(container => {
        container.innerHTML = '';
      });
      this.querySelectorAll('.selected-text').forEach(text => {
        const trigger = text.closest('.bundle-selector-trigger');
        if (trigger) {
          text.textContent = trigger.dataset.placeholder || 'Choose an option';
        }
      });
      // Remove any BXGY instructions
      this.querySelectorAll('.bxgy-instruction').forEach(el => el.remove());
      
      this.updateSummary();
      this.validateBundle();
    }

    setLoading(loading) {
      const btnText = this.addToCartBtn.querySelector('[data-atc-text]');
      const loader = this.addToCartBtn.querySelector('[data-atc-loader]');
      
      if (loading) {
        if (btnText) btnText.hidden = true;
        if (loader) loader.classList.remove('hidden');
        this.addToCartBtn.disabled = true;
      } else {
        if (btnText) btnText.hidden = false;
        if (loader) loader.classList.add('hidden');
        this.validateBundle();
      }
    }

    showError(message) {
      if (this.errorContainer) {
        this.errorContainer.textContent = message;
        this.errorContainer.hidden = false;
        
        // Auto-hide error after 5 seconds
        setTimeout(() => this.hideError(), 5000);
      }
    }

    hideError() {
      if (this.errorContainer) {
        this.errorContainer.hidden = true;
      }
    }

    formatMoney(cents) {
      const dollars = cents / 100;
      // If currency format contains {{ amount }}, replace it
      if (this.currency.includes('{{')) {
        return this.currency.replace(/\{\{\s*amount\s*\}\}/, dollars.toFixed(2));
      }
      // Otherwise, just return a simple formatted string
      return `$${dollars.toFixed(2)} AUD`;
    }
  }

  // Only define custom element once
  if (!customElements.get('product-bundle-builder')) {
    customElements.define('product-bundle-builder', ProductBundleBuilder);
  }

  // Handle dynamic section loading
  document.addEventListener('shopify:section:load', (event) => {
    const bundleBuilders = event.target.querySelectorAll('product-bundle-builder:not([data-initialized])');
    bundleBuilders.forEach(builder => {
      builder.connectedCallback();
    });
  });

  // Handle theme editor changes
  document.addEventListener('shopify:block:select', (event) => {
    const bundleBuilder = event.target.querySelector('product-bundle-builder');
    if (bundleBuilder && !bundleBuilder.hasAttribute('data-initialized')) {
      bundleBuilder.connectedCallback();
    }
  });
  console.log('Bundle Builder script loaded and initialized');
}